import * as dbHelper from "db";
import { SHOW_ALERT, showAlertAction } from "./ui";

export const COUPONS_LOADED = "coupons_loaded";


export const loadCoupons = () => dispatch => {
  return dbHelper.getCouponsRef()
    .onSnapshot(colSnap => {
      if (colSnap.size > 0) {
        dispatch({
          type: COUPONS_LOADED,
          payload: { coupons: colSnap.docs }
        })
      } else {
        dispatch({
          type: COUPONS_LOADED,
          payload: { coupons: [] }
        })
        dispatch(showAlertAction({
          message: "쿠폰이 없습니다",
          color: 'danger',
        }))
      }
    }
      , e => {
        const message = e.code === 'permission-denied'
          ? '권한이 없습니다. 관리자에게 문의해주세요.'
          : `에러가 발생했습니다. ${e.message}`
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            message,
            color: 'danger',
          }
        })
      });
}

export const createCoupon = (params) => dispatch => {
  return dbHelper.createCoupon(params)
    .catch(e => console.error('Failed to createCoupon: ', e));
}

export const updateCoupon = (coupon_id, params) => dispatch => {
  return dbHelper.updateCoupon(coupon_id, params)
    .catch(e => console.error('Failed to createCoupon: ', e));
}

export const removeCoupon = (coupon_id) => dispatch => {
  return dbHelper.removeCoupon(coupon_id)
    .catch(e => console.error('Failed to removeCoupon: ', e));
}

